// extracted by mini-css-extract-plugin
export default {"bringAi":"styles_bringAi__0K51b","tagline":"styles_tagline__UBkKe","headline":"styles_headline__FgXLA","desc":"styles_desc__K33Hv","more":"styles_more__fmQV3"};